<template>
    <div id="homefxRates" class="fx-rates">
        <ejs-grid :dataSource="fxRates" ref="fxRatesGrid" :allowPaging="true" :pageSettings='pageSettings' :queryCellInfo='customiseCell'>
            <e-columns>
                <e-column field='id' :disableHtmlEncode='false' headerText='Id' :width="100" :visible="false" textAlign='Left'></e-column>
                <e-column field='flag' :disableHtmlEncode='false' headerText='' textAlign='Left' :valueAccessor="valueAccessCurrency" width="40px"></e-column>
                <e-column field='name' :disableHtmlEncode='false' headerText='Name' textAlign='Left'></e-column>
                <e-column field='newRate' :disableHtmlEncode='false' headerText='Rate' textAlign='Center'></e-column>
                <e-column field='difference' :disableHtmlEncode='false' headerText='Difference' textAlign='Center'></e-column>
                <e-column field='percentageDiff' headerText='Percentage' :disableHtmlEncode='false' textAlign='Center'></e-column>
            </e-columns>
        </ejs-grid>
    </div>
</template>
<script>
    import Vue from "vue";
    import {
        GridPlugin,
        Page 
    } from "@syncfusion/ej2-vue-grids";
    Vue.use(GridPlugin);
    import apis from '@/common/network';
    import urls from '@/common/urls';
    import dates from '@/common/dates';
    import { getCurrencyFlagHtml } from '@/common/flags';

    export default {
        created() {
            this.fetchFxRatesData();
        },
        data() {
            return {
                fxDateVal: dates.addDays(new Date(), -7),
                fxRates:[],
                pageSettings: { pageSize: 9 }
            };
        },
        mounted() {
            //this.$refs.fxRatesGrid.height = "100%";
            //this.$refs.fxRatesGrid.width = "100%";
        },
        methods: {
            valueAccessCurrency: function (field, data, column) {
                return getCurrencyFlagHtml(data); // Make sure to return!
            },
            customiseCell: function (args) {

                if (args.data.difference > 0) {
                    if (!args.data.difference.includes("+") && !args.data.percentageDiff.includes("+")) {
                        args.data.difference = "+" + args.data.difference;
                        args.data.percentageDiff = "+" + args.data.percentageDiff + "%";
                    }
                    args.cell.classList.add("above-0");

                } else if (args.data.difference < 0) {
                    args.cell.classList.add("below-0");

                    if (!args.data.difference.includes("%") && !args.data.percentageDiff.includes("%")) {
                        var item = args.data.percentageDiff + "%";
                        args.data.percentageDiff = item;
                    }


                } else {

                    args.cell.classList.add('same-0');
                    if (!args.data.difference.includes("%") && !args.data.percentageDiff.includes("%")) {
                        var item = args.data.percentageDiff + "%";
                        args.data.percentageDiff = item;
                    }

                }
            },
            getFieldName: function (fieldName, data) {
                if (fieldName === "name") {
                    return data.name
                } else if (fieldName === "difference") {
                    return data.difference;
                } else if (fieldName === "percentageDiff") {
                    return data.percentageDiff + " " + "%";
                } else if (fieldName === "id") {
                    return data.id;
                } else if (fieldName === "newRate") {
                    return data.newRate;
                }
            },
            groupBy(arr, keyFunction) {
                const groups = {};
                arr.forEach(function (el) {
                    const key = keyFunction(el);
                    if (key in groups === false) {
                        groups[key] = [];
                    }
                    groups[key].push(el);
                });
                return groups;
            },
            // if diff is a positive number, it's an increase, otherwise it's a decrease
            calculatePercentageDiff(oldValue, newValue) {
                var diff = newValue - oldValue;
                return (diff / oldValue) * 100;
            },
            fetchFxRatesData() {
                apis.protectedApi(`${urls.apiBaseUrl}FXRate/FromDate?date=${this.fxDateVal.toISOString().split('T')[0]}`).then(fxr => {
                    let temp = [];
                    let fxrGrouped = this.groupBy(fxr.data.result, fx => fx.currencyConversionId);
                    const fxrArray = Object.keys(fxrGrouped).map(id => {
                        return {
                            id,
                            fxrGroups: fxrGrouped[id]
                        }
                    });
                    for (const fxrObj of fxrArray) {
                        if (fxrObj.fxrGroups.length >= 2) {
                            let oldFxRate = fxrObj.fxrGroups[fxrObj.fxrGroups.length - 2];
                            let newFxRate = fxrObj.fxrGroups[fxrObj.fxrGroups.length - 1];
                            let fxRate = {
                                id: newFxRate.currencyConversionId,
                                name: newFxRate.currencyConversionFrom + '-' + newFxRate.currencyConversionTo,
                                difference: (newFxRate.rate - oldFxRate.rate).toFixed(4),
                                newRate: newFxRate.rate.toFixed(4),
                                percentageDiff: (this.calculatePercentageDiff(oldFxRate.rate, newFxRate.rate)).toFixed(2)
                            }
                            temp.push(fxRate);
                        }
                    }      
                    this.fxRates = temp;
                    //this.$refs.fxRatesGrid.ej2Instances.dataSource = this.fxRates;
                    //this.$refs.fxRatesGrid.ej2Instances.refresh();
                    //this.resizePanel();
                }).catch(
                    //response => { this.handleError(response); }
                );
            },

            //resizePanel() {
            //    debugger;
            //    let panelContent = document.getElementsByClassName("fx-rates");
            //    let panelHeight = panelContent.offsetHeight;
            //    let panelWidth = panelContent.offsetWidth;
            //    let diff = Math.round(panelHeight / panelWidth);
            //    let instance = document.querySelector("#analysisLayout").ej2_instances[0];
            //    instance.resizePanel('panel0', 1, diff);
            //}
        },
        provide: {
            grid: [Page]
        }
    };
</script>

<style>
    .fx-rates .e-grid .e-gridheader {
        display: none;
    }

    .fx-rates .e-up:before {
        content: "\e56d";
    }

    .fx-rates .e-normal:before {
        content: "\e56f";
    }

    .fx-rates .e-down:before {
        content: "\e56e";
    }

    /*.fx-rates .e-icons {
        color: #00ffff;
        font-size: 16px;
    }*/

    .fx-rates .e-grid {
        border-style: none;
        border-radius: 0px;
       /* margin-left: 5px;*/
    }
    .below-0 {
        color: #1a9470 !important;
    }

    .above-0 {
        color: #f25c54 !important;
    }

    .same-0 {
        color: #001c55 !important;
    }

    .border-flag {
        border-radius: 8px;
        height: 16px;
        width: 16px;
    }
    .border-flagCur {
        height: 15px;
        width: 15px;
        border-radius: 8px;
    }


</style>